import React, { useState } from 'react';
import { ChevronDown, ChevronUp, List } from 'lucide-react';

interface SectionLink {
  id: string;
  label: string;
}

interface PageNavigatorProps {
  sections: SectionLink[];
}

export const PageNavigator: React.FC<PageNavigatorProps> = ({ sections }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 bg-white relative z-30">
      <div className="relative">
        <button
          onClick={() => setIsOpen(!isOpen)}
          className="flex items-center gap-2 bg-white border border-slate-200 px-4 py-2 rounded-sm text-slate-700 font-bold text-sm hover:bg-slate-50 transition-colors w-full md:w-auto justify-between md:justify-start shadow-sm"
          aria-expanded={isOpen}
        >
          <div className="flex items-center gap-2">
            <List size={16} className="text-orange-600" />
            <span>ON THIS PAGE</span>
          </div>
          {isOpen ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
        </button>

        {isOpen && (
          <div className="absolute top-full left-0 mt-2 w-full md:w-72 bg-white border border-slate-200 shadow-xl rounded-sm z-50 animate-fade-in">
            <ul className="py-2">
              {sections.map((section) => (
                <li key={section.id}>
                  <a
                    href={`#${section.id}`}
                    className="block px-4 py-3 text-sm text-slate-600 hover:bg-slate-50 hover:text-orange-600 transition-colors border-l-4 border-transparent hover:border-orange-600"
                    onClick={() => setIsOpen(false)}
                  >
                    {section.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </div>
  );
};
